import "core-js/modules/es.object.keys.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-34740434"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "NavAside"
};
var _hoisted_2 = {
  class: "Aside"
};
var _hoisted_3 = {
  class: "musicCate"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  key: 0,
  class: "userSheet"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_UserLogin = _resolveComponent("UserLogin");

  var _component_LoginDialog = _resolveComponent("LoginDialog");

  var _component_UserSheet = _resolveComponent("UserSheet");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 用户 "), _createVNode(_component_UserLogin, {
    onLoginClick: _ctx.loginClick
  }, null, 8
  /* PROPS */
  , ["onLoginClick"]), _createCommentVNode(" 登录对话框 "), _createVNode(_component_LoginDialog, {
    ref: "logDialog"
  }, null, 512
  /* NEED_PATCH */
  ), _createCommentVNode(" 音乐歌单等菜单 "), _createElementVNode("div", _hoisted_2, [_createCommentVNode(" 菜单类型 "), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicCate, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['cate-box', _ctx.isRouter === item.router ? 'active' : '']),
      key: item,
      onClick: function onClick($event) {
        return _ctx.activeClick(item.router);
      }
    }, [_createElementVNode("i", {
      class: _normalizeClass('iconfont ' + item.icon)
    }, null, 2
    /* CLASS */
    ), _createElementVNode("span", null, _toDisplayString(item.title), 1
    /* TEXT */
    )], 10
    /* CLASS, PROPS */
    , _hoisted_4);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]), _createCommentVNode(" 用户歌单项 "), Object.keys(_ctx.userData).length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createCommentVNode(" 创建和收藏的歌单 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSheetType, function (type) {
    return _openBlock(), _createElementBlock("div", {
      class: "sheet-type",
      key: type
    }, [_createCommentVNode(" 歌单项 "), _createVNode(_component_UserSheet, {
      sheetType: type.type,
      sheetList: _ctx.userSheet[type.data]
    }, null, 8
    /* PROPS */
    , ["sheetType", "sheetList"])]);
  }), 128
  /* KEYED_FRAGMENT */
  ))])) : _createCommentVNode("v-if", true)]);
}